"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeTrackDisplayFormats = void 0;
exports.timeTrackDisplayFormats = ["pill", "text"];
